export default __webpack_public_path__ + "resources/icons/d442-4a7f.webp";